import axios from 'axios';
import jwt_decode from "jwt-decode";

import {userGroupUrlCheck} from '../utils/userGroupUrlCheck';
import {setStorage} from '../utils/browserStorage'; 
import {URL_BASE_API } from '../configs/urlConfigs';
import {LOGIN_SUPER_ADMIN_GROUP,LOGIN_AFFILIATE_GROUP,LOGIN_CLIENT_GROUP} from '../configs/staticConfigs';


export function checkAccessToken(userGroupData) {
    let ugData = userGroupData; 
    var decoded = jwt_decode(userGroupData.accessToken);  
    var aTokenMSec = decoded.exp*1000;
    var currentMSec = new Date().getTime();

    let d1 = new Date(aTokenMSec); 
    let d2 = new Date(currentMSec); 
    
    if(currentMSec >= aTokenMSec) { // ACCESS TOKEN EXPIRED, CALL REFRESH TOKEN API 
        let data = {"refresh": userGroupData.refreshToken}
        let path = URL_BASE_API+'token-refresh/'; 

        const client = axios.create({
            baseURL: URL_BASE_API,
            timeout: 0 * 2 * 1000,//Two minutes
            headers: {
                'Content-Type': 'application/json',
            }
        });  

       let retStr = client.post(path, data).then(response => {
            // return response;
            console.log('refresh Token response : '+response.data.access);
            if(response.status===200) {
                ugData.accessToken = response.data.access; 
                if(userGroupData.userGroup===LOGIN_SUPER_ADMIN_GROUP){
                    setStorage('super', JSON.stringify(ugData));
                }else if(userGroupData.userGroup===LOGIN_AFFILIATE_GROUP){
                    setStorage('affiliate', JSON.stringify(ugData));
                }else if(userGroupData.userGroup===LOGIN_CLIENT_GROUP){
                    setStorage('client', JSON.stringify(ugData));
                }
                return response.data.access;  
            }
            else {
                return userGroupData.accessToken; 
            }
        }).catch(error=>{
            let errorResp = {      
                status: error.response.status,
                statusText: error.response.statusText,
                data:error.response.data
            };      
            // return errorResp;
            return userGroupData.accessToken; 
        }); 
        return retStr; 
    }
    else {
        return userGroupData.accessToken; 
    }
}

let unid            = '';
let userGroupToken  = '';
let affiliateId     = '';
let userGroup       = '';

class ApiService {    

    get(path) {    
        
        let userGroupData = userGroupUrlCheck(window.location);
        if(userGroupData!==undefined){
            unid              = userGroupData.unid;
            userGroupToken    = userGroupData.accessToken;
            affiliateId       = userGroupData.client_default_affiliate_id;
            userGroup         = userGroupData.user_group; 
        }    

        // let response = await fetch(URL_BASE_API+'token-refresh/', {
        //     method: 'POST',
        //     headers: {
        //       'Content-Type': 'application/json;charset=utf-8'
        //     },
        //     body: JSON.stringify(user)
        //   });

        let reStr = checkAccessToken(userGroupData);
        if(typeof reStr ==='string') {
            userGroupToken = reStr; 
        }
        else  if(typeof reStr ==='object') {
            console.log('token change: '); 
            userGroupToken = reStr.then(function(val) { 
                return val;
            }); 
        }

        const client = axios.create({
            baseURL: URL_BASE_API,
            timeout: 60 * 2 * 1000,//Two minutes
            headers: {
                'Content-Type': 'application/json',
                'Authorization':'Bearer '+userGroupToken,
                'unid':unid,
                ...(userGroup===LOGIN_CLIENT_GROUP && {'affiliate' : affiliateId})
            }
        });  

        return client.get(path).then(response => {
            return response;
        }).catch(error=>{
        let errorResp = {      
            status: error.response.status,
            statusText: error.response.statusText,
            data:error.response.data
        };      
        return errorResp;
        }); 


        /*
        return reStr.then(function(val) { 

            if(userGroupData.accessToken!==val) {
                console.log('11: '+userGroupData.accessToken); 
                console.log('22: '+val); 
            }

            const client = axios.create({
                baseURL: URL_BASE_API,
                timeout: 60 * 2 * 1000,//Two minutes
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization':'Bearer '+val,
                    'unid':unid,
                    ...(userGroup===LOGIN_CLIENT_GROUP && {'affiliate' : affiliateId})
                }
            });  
    
            return client.get(path).then(response => {
                return response;
            }).catch(error=>{
            let errorResp = {      
                status: error.response.status,
                statusText: error.response.statusText,
                data:error.response.data
            };      
            return errorResp;
            }); 
            
        }); 
        */ 
    }

    post(path,data){

        let userGroupData = userGroupUrlCheck(window.location);
        if(userGroupData!==undefined){
            unid              = userGroupData.unid;
            userGroupToken    = userGroupData.accessToken;
            affiliateId       = userGroupData.client_default_affiliate_id;
        }    
        

        const client = axios.create({
            baseURL: URL_BASE_API,
            timeout: 0 * 2 * 1000,//Two minutes
            headers: {
                'Content-Type': 'application/json',
                'Authorization':'Bearer '+userGroupToken,
                'unid':unid,
                ...(userGroup===LOGIN_CLIENT_GROUP && {'affiliate' : affiliateId})
            }
        });  

        return client.post(path, data).then(response => {
            return response;
        }).catch(error=>{
        let errorResp = {      
            status: error.response.status,
            statusText: error.response.statusText,
            data:error.response.data
        };      
        return errorResp;
        }); 
    }

    put(path,data) {

        let userGroupData = userGroupUrlCheck(window.location);
        if(userGroupData!==undefined){
            unid              = userGroupData.unid;
            userGroupToken    = userGroupData.accessToken;
            affiliateId       = userGroupData.client_default_affiliate_id;
        }    
       
        const client = axios.create({
            baseURL: URL_BASE_API,
            timeout: 60 * 2 * 1000,//Two minutes
            headers: {
                'Content-Type': 'application/json',
                'Authorization':'Bearer '+userGroupToken,
                'unid':unid,
                ...(userGroup===LOGIN_CLIENT_GROUP && {'affiliate' : affiliateId})
            }
        });  

        return client.put(path, data).then(response => {
            return response;
        }).catch(error=>{
        let errorResp = {      
            status: error.response.status,
            statusText: error.response.statusText,
            data:error.response.data
        };      
        return errorResp;
        }); 
    }

    delete(path) {

        let userGroupData = userGroupUrlCheck(window.location);
        if(userGroupData!==undefined){
            unid              = userGroupData.unid;
            userGroupToken    = userGroupData.accessToken;
            affiliateId       = userGroupData.client_default_affiliate_id;
        }    
       
        const client = axios.create({
            baseURL: URL_BASE_API,
            timeout: 60 * 2 * 1000,//Two minutes
            headers: {
                'Content-Type': 'application/json',
                'Authorization':'Bearer '+userGroupToken,
                'unid':unid,
                ...(userGroup===LOGIN_CLIENT_GROUP && {'affiliate' : affiliateId})
            }
        });  

        return client.delete(path).then(response => {
            return response;
        }).catch(error=>{
        let errorResp = {      
            status: error.response.status,
            statusText: error.response.statusText,
            data:error.response.data
        };      
        return errorResp;
        }); 
    }
}

export default new ApiService()